<div class="relative inline-block">
  <button
    (click)="toggle()"
    class="flex items-center gap-4 bg-white rounded-lg px-6.5 py-3.5 text-th-black text-[16px] font-medium cursor-pointer hover:bg-th-light-blue transition-colors select-none shadow-xl"
  >
    <img src="icons/filter_icon.svg" class="w-6 h-6" />

    <span>Ordenar por</span>

    <img src="icons/select_icon.svg" class="w-6 h-6" [class.rotate-180]="isOpen()" />
  </button>

  @if (isOpen()) {
    <div class="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-md z-50 min-w-52 py-1">
      <mat-radio-group [value]="selectedOption()">
        @for (option of options; track option.value) {
          <label
            class="flex items-center px-2 py-1 cursor-pointer hover:bg-th-light-blue transition-colors w-77"
            (click)="onSelect(option)"
          >
            <mat-radio-button
              [value]="option.value"
              [checked]="selectedOption() === option.value"
              (click)="$event.preventDefault()"
            ></mat-radio-button>
            <span class="text-th-black text-[14px] font-medium">{{ option.label }}</span>
          </label>
        }
      </mat-radio-group>
    </div>
  }
</div>
